import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    shipAt: {
      id: 'properties.shipAt',
      defaultMessage: 'Ship at',
      description: 'label of the ship at field',
    },
    trackingCode: {
      id: 'properties.trackingCode',
      defaultMessage: 'Track & Trace code',
      description: 'label of the tracking code field',
    },
    trackingUrl: {
      id: 'properties.trackingUrl',
      defaultMessage: 'Track & Trace URL',
      description: 'label of the tracking url field',
    },
    height: {
      id: 'properties.height',
      defaultMessage: 'Height',
      description: 'label of the height field',
    },
    width: {
      id: 'properties.width',
      defaultMessage: 'Width',
      description: 'label of the width field',
    },
    length: {
      id: 'properties.length',
      defaultMessage: 'Length',
      description: 'label of the length field',
    },
    weight: {
      id: 'properties.weight',
      defaultMessage: 'Weight',
      description: 'label of the weight field',
    },
    position: {
      id: 'properties.position',
      defaultMessage: 'Position',
      description: 'label of the position field',
    },
  },
};

export default defineMessages(translations);
